export * from './register-success.component';
